import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { getModalInstructions, userNameTakenTitle } from './utils';
import { MFBeaconIconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import styles from './styles.css';

const CredentialsValidationModal = () => {
  const { appState, closeNextModal } = useContext(FlowContext);
  const {
    store: { loadedData }
  } = appState;

  const modalTitle = loadedData?.usernameTaken ? userNameTakenTitle : '';
  const modalInstructions = getModalInstructions(loadedData);

  return (
    <>
      <MFBeaconModal scale="mini" open removeCloseButton>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            variant="tertiary"
            onClick={() => {
              modalCloseNextModalHandler(closeNextModal);
            }}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">{modalTitle}</div>
        <div className="beacon-modal__description">{modalInstructions}</div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default CredentialsValidationModal;
